import React from "react";
import MainContainer from "../../components/MainContainer";
import { Container } from "./TrainPage.styles";
import Train from "../../components/Train/Train";
import { useDispatch } from "react-redux";
import { setSignUpModalOpen } from "../../store/slices/common/slice";

const TrainPage = () => {
  const dispatch = useDispatch();

  return (
    <MainContainer offPadding hideTabs={false}>
      <Container>
        <Train
          onLoginClick={() => {
            dispatch(setSignUpModalOpen(true));
          }}
        />
      </Container>
    </MainContainer>
  );
};

export default TrainPage;
